export default defineAppConfig({
  ui: {
    colors: {
        primary: 'green',
        neutral: 'zinc',
        tertiary: 'blue'
    },
    skeleton: {
      base: 'animate-pulse rounded-md bg-elevated'
    }
  },
  toaster: {
    position: 'bottom-right' as const,
    expand: true,
    duration: 1000
  },
})
